import clsx from "clsx";
import { memo } from "react";

interface Props {
  className?: string;
  children: string;
  absolute?: boolean;
}

const ErrorMessage = memo(({ className, children, absolute }: Props) => {
  return (
    <span
      className={clsx(
        "inline-block text-12 text-red px-3",
        { "absolute bottom-[-1.375rem]": absolute },
        className,
      )}
    >
      {children}
    </span>
  );
});

ErrorMessage.displayName = "ErrorMessage";

export default ErrorMessage;
